import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/site/PageHero";
import Reveal from "@/components/site/Reveal";
import JourneyTile from "@/components/site/JourneyTile";
import { usePageMeta } from "@/components/site/SEO";
import { JOURNEYS } from "@/content/journeys";

export default function Journeys() {
  usePageMeta(
    "Journeys",
    "Place-based learning journeys for schools: Tide Trails in Goa and Lessons from the Wild in Pench, with more destinations coming soon.",
  );

  return (
    <>
      <PageHero
        eyebrow="Journeys"
        title="Journeys for schools"
        intro="Two programmes are open for school groups now, with more destinations on the way. Each journey is built around a place, its people and the questions it raises."
      />

      <section className="container-x pb-20 sm:pb-28" data-testid="journeys-list">
        <div className="grid gap-12 md:grid-cols-2 lg:gap-16">
          {JOURNEYS.map((journey, i) => (
            <JourneyTile key={journey.slug} journey={journey} delay={i * 0.1} />
          ))}
        </div>

        <div className="mt-20 border-t border-line">
          <Reveal>
            <Link
              to="/journeys/coming-soon"
              data-testid="journeys-coming-soon-link"
              className="group flex flex-wrap items-baseline justify-between gap-4 border-b border-line py-8"
            >
              <div>
                <h2 className="text-2xl font-medium tracking-tight sm:text-3xl">Coming Soon</h2>
                <p className="mt-2 max-w-xl text-base text-ink/70">
                  Pondicherry, Jaipur, Hampi and Ladakh in India, with Japan, South Korea and
                  Indonesia beyond.
                </p>
              </div>
              <span className="inline-flex items-center gap-2 text-base font-medium text-pine">
                See where we wander next
                <ArrowRight
                  className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
                  aria-hidden="true"
                />
              </span>
            </Link>
          </Reveal>
          <Reveal>
            <Link
              to="/journeys/bespoke-experiences"
              data-testid="journeys-bespoke-link"
              className="group flex flex-wrap items-baseline justify-between gap-4 border-b border-line py-8"
            >
              <div>
                <h2 className="text-2xl font-medium tracking-tight sm:text-3xl">
                  Bespoke Experiences
                </h2>
                <p className="mt-2 max-w-xl text-base text-ink/70">
                  For families, individuals and private, adult and corporate groups. Currently
                  developing.
                </p>
              </div>
              <span className="inline-flex items-center gap-2 text-base font-medium text-pine">
                Find out more
                <ArrowRight
                  className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
                  aria-hidden="true"
                />
              </span>
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
